import React from 'react'
import { compose, withState } from 'recompose'
import { withStyles } from '@material-ui/core/styles'

import withFirebase from '../../withFirebase'
import PhoneNumberInput from './PhoneNumberInput'
import VerificationCodeInput from './VerificationCodeInput'

const App = ({ classes, firebase, confirmHandler, setConfirmHandler }) => {
  const signIn = ({ phoneNumber }) => {
    console.log(phoneNumber)
    firebase.auth().useDeviceLanguage()
    const auth = require('firebase').auth
    const appVerifier = new auth.RecaptchaVerifier('recaptcha-container')

    return firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(function(confirmationResult) {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        console.log('SMS sent!')
        setConfirmHandler(confirmationResult)
      })
      .catch(function(error) {
        console.log('Error; SMS not sent!', error)
        // Error; SMS not sent
        // window.recaptchaVerifier.render().then(function(widgetId) {
        //   grecaptcha.reset(widgetId)
        // })
      })
  }

  const confirmCode = ({ codeInput }) => {
    console.log(codeInput)
    if (confirmHandler && codeInput.length) {
      return confirmHandler
        .confirm(codeInput)
        .then(user => {
          console.log('#confirm', user)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }

  return !confirmHandler ? (
    <PhoneNumberInput onSubmit={signIn} />
  ) : (
    <VerificationCodeInput onSubmit={confirmCode} />
  )
}

const styles = theme => {
  return {}
}

export default compose(
  withFirebase,
  withStyles(styles),
  withState('confirmHandler', 'setConfirmHandler', null)
)(App)
